import React, { useEffect, useState } from 'react';
import StudentWrapper from '../../StudentWrapper';
import Button from '../../../components/Button';
import AddPayment from '../addPayment/AddPayment';
import { useParams } from 'react-router-dom/dist';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../components/Loader/Loader';
import { toast } from 'react-toastify';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'; // For spinner icon
import Input from '../../../components/Input';

const StudentCourceDetails = () => {
  const [open, setOpen] = useState(false);
  const [courseDetails, setCourseDetails] = useState();
  const [searchQuery, setSearchQuery] = useState('');

  console.log(courseDetails);

  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  useEffect(() => {
    fetchCourseDetails(id);
  }, [id]);

  const fetchCourseDetails = (courseId) => {
    setLoader(true);
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(`https://quran-backend-theta.vercel.app/v1/user/course/${courseId}`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        // console.log("DATA", data?.course);
        setCourseDetails(data?.course);
        setLoader(false);
      })
      .catch((error) => console.error(error));
  };

  const Admission = (id) => {
    const user = localStorage.getItem('userData');
    let userData = JSON.parse(user);
    setLoading(true); // Show loader
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    const raw = JSON.stringify({
      courseId: id
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch(
      `https://quran-backend-theta.vercel.app/v1/user/admission/${userData?._id}`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        // console.log("DATA", data);
        if (data?.success === true) {
          toast.success('Admission successful! 🎉');
          navigate('/my-cources');
        } else {
          toast.error(data?.error || 'Something went wrong. Please try again.');
        }
        setLoading(false); // Show loader
      })
      .catch((error) => {
        setLoading(false); // Show loader

        toast.error(error);
      });
  };

  return (
    <StudentWrapper
      searchBar={
        <Input
          placeholder={`Search by  course name...`}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          Icon={
            <img
              src={require('../../../assets/image/Search-Magnifier.png')}
              className=" w-8"
              alt=""
            />
          }
          className={' w-full bg-white  pl-12'}
        />
      }
    >
      <AddPayment setIsModalOpen={setOpen} isModalOpen={open} />
      <div className=" flex justify-between items-center ">
        <div>
          <h2 className="main_title ">{courseDetails?.name}</h2>
          <p className=" text-[#1C1D1D]">Here are details of your Course</p>
        </div>
        <div></div>
      </div>

      <section className=" pt-2">
        <div className=" py-4  w-full grid  grid-cols-1  xl:grid-cols-2 md:grid-cols-2 gap-5">
          <div className=" w-full">
            <div
              className="  bg-white p-5 rounded-lg flex  justify-between"
              style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
            >
              <div>
                <h2 className=" text-[#1C1D1D] text-[20px] font-semibold">Completed Lessons</h2>
                <div className=" pt-2 flex items-center gap-3">
                  <p className="text-lg pt-3  text-[#1C1D1D]">5000</p>
                </div>
              </div>
              <div>
                <img src={require('../../../assets/image/completed.png')} alt="" />
              </div>
            </div>
          </div>
          <div className=" w-full">
            <div
              className=" bg-white  flex justify-between p-5 rounded-lg"
              style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
            >
              <div>
                <h2 className=" text-[#1C1D1D] text-[20px] font-semibold">Absents </h2>
                <div className=" pt-2 flex items-center gap-3">
                  <p className="text-lg pt-3 text-black">50</p>
                </div>
              </div>
              <div>
                <img src={require('../../../assets/image/absent.png')} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <h1 className=" text-xl mt-4 text-[#1C1D1D] font-semibold">Cource Details</h1>
        {loader === true ? <Loader /> : null}

        <div
          className=" p-3 mt-5 rounded-lg"
          style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
        >
          <span className=" m-0 text-gray-400 text-sm">Cource Name</span>
          <h6 className=" text-lg">{courseDetails?.name}</h6>

          <span className=" pt-3 m-0 text-gray-400 text-sm">Description</span>
          <h6 className="">{courseDetails?.description}</h6>

          <ul className=" flex flex-col gap-2 mt-5">
            <li>
              <div className=" flex gap-1 items-center">
                <div>
                  <img src={require('../../../assets/image/Graduation Cap.png')} alt="" />
                </div>
                <p>{courseDetails?.lesson} Lessons</p>
              </div>
            </li>
            <li>
              <span className=" m-0 text-gray-400 text-sm">Price</span>

              <p className=" pb-2">Rs {courseDetails?.price}</p>
              <button
                onClick={() => Admission(courseDetails?._id)}
                disabled={loading}
                className="bg-[#007AFF] px-5 py-2.5 text-white text-center flex items-center gap-2 justify-center rounded-lg font-medium"
              >
                {loading && (
                  <AiOutlineLoading3Quarters className="animate-spin text-white text-lg" />
                )}
                Admission Now
              </button>
            </li>

            <li>
              <span className=" m-0 text-gray-400 text-sm">Duration</span>
              <p>
                {courseDetails?.duration} {courseDetails?.periodType}
              </p>
            </li>
          </ul>
        </div>
      </section>
    </StudentWrapper>
  );
};

export default StudentCourceDetails;
